import {SSP_PARTNER_AD_MODES} from '@web-landing/components/MultiProviderFloorAd.tsx/consts';

import {
  AdFoxConfigValidator,
  ConfigSchema,
  getBoolean,
  getBooleanNumberMap,
  getNumber,
  getString,
  getStringMap,
  getStringUnion,
  InferConfigType,
  OmicronConfigResponseType,
  WithTypeCheck,
} from '@utils/omicron';

export const OmicronConfigSchema = {
  QR_REDIRECTS: {
    value: getStringMap(),
    description:
      'Набор ссылок для редиректа при переходе на rustore.ru/offers/qr',
    team: 'Growth',
  },
  SSP_BANNER_REFRESH: {
    value: getBooleanNumberMap(),
    description: `JSON Настройка перезапросов ssp рекламы`,
    team: 'Ads',
  },
  WEB_SHOW_BEELINE: {
    value: getBoolean(),
    description: 'Флаг на показ партнерской страницы Beeline',
    team: 'Growth',
  },
  WEB_SHOW_DVIJENIE_PERVIKH: {
    value: getBoolean(),
    description: 'Флаг на показ партнерской страницы "Движение первых"',
    team: 'Growth',
  },
  WEB_BEELINE_OFFER: {
    value: getString(),
    description: 'Текст оферты партнерской страницы Beeline',
    team: 'Growth',
  },
  WEB_DVIJENIE_PERVIH_OFFER: {
    value: getString(),
    description: 'Текст оферты партнерской страницы "Движение первых"',
    team: 'Growth',
  },
  WEB_SHOW_RUSTORE_OPEN: {
    value: getBoolean(),
    description: 'Флаг на показ формы "Предложить приложение" ',
    team: 'Growth',
  },
  WEB_SHOW_PROSTORE_PAGE: {
    value: getBoolean(),
    description: 'Флаг на показ списка статей в блоге',
    team: 'Growth',
  },
  WEB_SHOW_AURORA_PAGE: {
    value: getBoolean(),
    description: 'Флаг на показ страницы ОС Аврора',
    team: 'Growth',
  },
  WEB_SHOW_REDESIGN: {
    value: getBoolean(),
    description: 'Флаг на показ варианта лендинга с редизайном',
    team: 'Growth',
  },
  WEB_SHOW_KIDS_PAGE: {
    value: getBoolean(),
    description: 'Флаг на показ страницы родительского контроля',
    team: 'Growth',
  },
  WEB_SHOW_INSTRUCTION_REDESIGN: {
    value: getBoolean(),
    description: 'Флаг на показ страницы инструкции в новом виде (редизайн)',
    team: 'Growth',
  },
  WEB_SHOW_AUTOUPDATE_PAGE: {
    value: getBoolean(),
    description: 'Флаг на показ страницы "Автообновления приложений RuStore" ',
    team: 'Growth',
  },
  WEB_SHOW_CAREER_PAGE: {
    value: getBoolean(),
    description: 'Флаг на показ страницы карьеры',
    team: 'Growth',
  },
  WEB_SHOW_LOCALIZATION: {
    value: getBoolean(),
    description: 'Флаг на показ локализации главной страницы лединга витрины',
    team: 'Growth',
  },
  DOWNLOAD_HINT_SHOW_TIME: {
    value: getNumber(),
    description:
      'Флаг на показ подсказки, где найти файл после скачивания apk RuStore',
    team: 'Growth',
  },
  ENABLE_INSTRUCTION_FAQ: {
    value: getBoolean(),
    description:
      'Флаг на показ блоков FAQ на страницах инструкции по установке РуСтор для мобилки и ТВ',
    team: 'Growth',
  },
  ENABLE_BLOG_AUTHORS: {
    value: getBoolean(),
    description: 'Флаг на показ информации об авторах статей',
    team: 'Growth',
  },
  ENABLE_TIME_TO_READ: {
    value: getBoolean(),
    description: 'Флаг на показ информации времени чтения статьи',
    team: 'Growth',
  },
  ENABLE_CATEGORIES_PAGE: {
    value: getBoolean(),
    description:
      'Флаг на показ страниц категорий в блоге + редизайн главной страницы блога',
    team: 'Growth',
  },
  ENABLE_CAR_PAGE: {
    value: getBoolean(),
    description:
      'Флаг на показ страницы с инструкцией по установке RuStore на авто',
    team: 'Growth',
  },
  //>>> Тогглы рекламы
  LANDING_YANDEX_AD_MODE: {
    value: getStringMap(),
    description: 'Режимы рекламы Яндекса в витрине',
    team: 'Growth',
  },
  LANDING_SSP_AD_MODE: {
    value: getStringMap(),
    description: 'Флаг на отображение типа рекламы SSP',
    team: 'Ads',
  },
  LANDING_SSP_AD_PARTNER: {
    value: getStringUnion('none', SSP_PARTNER_AD_MODES),
    description: 'Флаг типа партнеров рекламы SSP',
    team: 'Ads',
  },
  ADFOX_CONFIG: {
    value: AdFoxConfigValidator,
    description:
      'Тоггл отвечает за переключение между прямой интеграцией с РСЯ и AdFox',
    team: 'Growth',
  },
  ENABLE_AUTO_DOWNLOAD_ANYWHERE: {
    value: getBoolean(),
    description: 'Флаг для автоскачивания из любых источников',
    team: 'Growth',
  },
  ENABLE_CATEGORIES: {
    value: getStringUnion('', ['default', 'colored'] as const),
    description: 'Тоггл на включение категорий на главной',
    team: 'Growth',
  },
  ENABLE_PROSTORE_SWITCHER: {
    value: getBoolean(),
    description:
      'Включает показ переключалки между статьями дев блога и простора на странице автора',
    team: 'Growth',
  },
  ENABLE_PREVIEW_KIOSK: {
    value: getBoolean(),
    description: 'Включает превью киоска на главной',
    team: 'Growth',
  },
  AURORA_DOWNLOADING_ENABLE: {
    value: getBoolean(),
    description: 'Тогл, включающий возможность скачать RuStore для Aurora OS',
    team: 'Pandora',
  },
  ENABLE_PROSTORE_FEATURES: {
    value: getBoolean(),
    description: 'Тоггл, включающий акции в статьях простора',
    team: 'Growth',
  },
} satisfies ConfigSchema;

export type OmicronConfigType = InferConfigType<
  WithTypeCheck<typeof OmicronConfigSchema>
>;

export type OmicronResponse = OmicronConfigResponseType<OmicronConfigType>;
